import Login from 'views/Login';
import ResetPassword from 'views/ResetPassword';

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    exact: true
  },
  {
    path: '/reset-password',
    name: 'Reset Password',
    component: ResetPassword,
    exact: false
  }
];

export default routes;
